import { IconFieldDesignTokens } from '../../../../types/iconfield';

export default {
    icon: {
        color: '{form.field.icon.color}'
    }
} as IconFieldDesignTokens;
